import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

// export lazy route
const Legal = lazy(() => import("./Legal"));

const LEGAL_ROUTES: RouteObject[] = [
  {
    path: "/public/legal",
    element: React.createElement(Legal),
  },
];

export default LEGAL_ROUTES;
